//Generated File 
export default class RepOutputFormat{
	static readonly DOCX = `DOCX`;
	static readonly HTML = `HTML`;
	static readonly JasperPrint = `JasperPrint`;
	static readonly ODS = `ODS`;
	static readonly ODT = `ODT`;
	static readonly PDF = `PDF`;
	static readonly PPTX = `PPTX`;
	static readonly RTF = `RTF`;
	static readonly TXT = `TXT`;
	static readonly XLS = `XLS`;
	static readonly XLSX = `XLSX`;
}
